﻿import '@mdi/font/css/materialdesignicons.css'
import es from 'vuetify/es5/locale/es'

import Vue from 'vue'

import Vuetify, { VApp, VAppBar, VAppBarTitle, VAppBarNavIcon, VToolbarTitle, VMain, VContent, VContainer, VFooter, VNavigationDrawer,
    VBtn, VBtnToggle, VIcon, VCol, VProgressLinear, VProgressCircular, VDialog,
    VCard, VCardTitle, VCardSubtitle, VCardText, VCardActions, VStepper, VStepperItems, VStepperStep, VStepperHeader, VStepperContent,
    VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent,
    VDivider, VTextField, VTextarea, VSelect, VRow, VTooltip, VAlert, VImg, VSpacer, VCheckbox, VSimpleCheckbox, VSwitch, VSimpleTable, VDataTable,
    VRadio, VRadioGroup, VAutocomplete, VForm, VRating, VSheet, VBadge, VSnackbar, VSubheader, VSlider, VDatePicker, VTimePicker,
    VList, VListItem, VListItemContent, VListItemTitle, VListItemSubtitle, VListItemAction, VListItemActionText, VListItemGroup, VListItemIcon
} from 'vuetify/lib'

Vue.use(Vuetify, {
    components: { VApp, VAppBar, VAppBarTitle, VAppBarNavIcon, VToolbarTitle, VMain, VContent, VContainer, VFooter, VNavigationDrawer,
        VBtn, VBtnToggle, VIcon, VCol, VProgressLinear, VProgressCircular, VDialog,
        VCard, VCardTitle, VCardText, VCardSubtitle, VCardActions, VStepper, VStepperItems, VStepperStep, VStepperHeader, VStepperContent,
        VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent,
        VDivider, VTextField, VTextarea, VSelect, VRow, VTooltip, VAlert, VImg, VSpacer, VCheckbox, VSimpleCheckbox, VSwitch, VSimpleTable, VDataTable,
        VRadio, VRadioGroup, VAutocomplete, VForm, VRating, VSheet, VBadge, VSnackbar, VSubheader, VSlider, VDatePicker, VTimePicker,
        VList, VListItem, VListItemContent, VListItemTitle, VListItemSubtitle, VListItemAction, VListItemActionText, VListItemGroup, VListItemIcon
    }
})

const opts = {
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: '#0050B3',
                secondary: '#446CA1',
                accent: '#FB9C00'
            }
        },
        options: { customProperties: true }
    },
    lang: {
        locales: { es },
        current: 'es'
    }
}

export default new Vuetify(opts)